import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const MinimalFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border/50 py-10 px-6">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <Logo className="w-5 h-5" />
          <span>© {year} Lacrea</span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-5">
          <Link to="/qui-sommes-nous" className="hover:text-foreground transition-colors">Qui sommes nous ?</Link>
          <Link to="/realisations" className="hover:text-foreground transition-colors">Réalisations</Link>
          <Link to="/blog" className="hover:text-foreground transition-colors">Blog</Link>
          <Link to="/mentions-legales" className="hover:text-foreground transition-colors">Mentions légales</Link>
          <Link to="/politique-confidentialite" className="hover:text-foreground transition-colors">Confidentialité</Link>
          <a href="mailto:contact@lacrea.fr" className="hover:text-foreground transition-colors">contact@lacrea.fr</a>
        </nav>
      </div>
    </footer>
  );
};

export default MinimalFooter;
